var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ELEMENTS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.976,
    viewBox: "0 0 20 19.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M7.706,14.294h4.156V27.635H7.706ZM9.784,7.66a2.455,2.455,0,1,0,.041,0",
    transform: "translate(-7.38 -7.66)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M16.07,15.716h4.018v1.793h0a4.36,4.36,0,0,1,3.928-2.16c4.2,0,4.971,2.763,4.971,6.357v7.335H24.864v-6.52c0-1.548,0-3.537-2.16-3.537s-2.486,1.687-2.486,3.423v6.6H16.07Z",
    transform: "translate(-8.988 -9.082)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn1);
export default __webpack_public_path__ + "static/media/linkedIn_1.346d046a4f485fb48860bcf101702fe6.svg";
export { ForwardRef as ReactComponent };